module.exports = __webpack_public_path__ + "static/img/14000750.a1d8115c.png";